// This alphabet uses `A-Za-z0-9_-` symbols. The genetic algorithm helped
// optimize the gzip compression for this alphabet.
let urlAlphabet =
  'ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW'

export { urlAlphabet }



//////////////////
// WEBPACK FOOTER
// ./node_modules/nanoid/url-alphabet/index.js
// module id = 393
// module chunks = 1